
import { Options, Vue } from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import { GarmentClient } from '@/services/Services';
import debounce from 'lodash.debounce';
import selectGenders from '../../../components/selectGenders.vue';
import SelectGarmentProperties from '../../../components/selectGarmentProperties.vue';
import store from '@/store';
import * as OM from '@/Model';
import * as VM from '@/viewModel';

@Options({
    components: {
        selectGenders,
        SelectGarmentProperties
    }
})
export default class Editbaseinformation extends Vue {

    @Prop() estimationIdentifier: string;
    @Prop() garmentConfigurationIdentifier: string;
    @Prop() saveToGarmentConfiguration: boolean;

    estimationBaseInformation: OM.EstimationBaseInformationVM = new OM.EstimationBaseInformationVM();
    garmentConfiguration: OM.MyGarmentConfigurationsVM = new OM.MyGarmentConfigurationsVM();
    bothWastagePercentage: number = 0;
    hasExtraPockets: boolean = false;
    
    created() {
        Promise.all([
            store.state.estimationClient.getBaseInformation(this.estimationIdentifier),
            GarmentClient.getMyGarmentConfigurationsVM(this.garmentConfigurationIdentifier)
        ])
        .then( xs => {
            this.estimationBaseInformation = xs[0];
            this.garmentConfiguration = xs[1];

            var firstGarmentLayer = this.estimationBaseInformation.garmentPropertyLayers[0];
            this.bothWastagePercentage = firstGarmentLayer.wastagePercentage;

            if(this.estimationBaseInformation.extraPocketsNumber > 0)
                this.hasExtraPockets = true;
        })
    }

    get isReadOnly() {
        return store.state.loggedUser.role == VM.Roles.ReadOnly;
    }

    updateGarmentLayer(value: OM.GarmentPropertyLayer, index: number) {
        this.estimationBaseInformation.garmentPropertyLayers[index] = value;
    }
    updateGenderForBothGarmentLayer(event: string) {
        if(this.estimationBaseInformation.garmentPropertyLayers.length <= 1)
            return;
        
        for(var i = 0; i < this.estimationBaseInformation.garmentPropertyLayers.length; i++) {
            this.estimationBaseInformation[i] = event;
            this.estimationBaseInformation.garmentPropertyLayers[i].gender = event;
            this.estimationBaseInformation.garmentPropertyLayers[i].properties = [];
        }
    }
    updateEUSizeForBothGarmentLayer(event: string) {
        if(this.estimationBaseInformation.garmentPropertyLayers.length <= 1)
            return;
        
        for(var i = 0; i < this.estimationBaseInformation.garmentPropertyLayers.length; i++) {
            var existItem = this.estimationBaseInformation.garmentPropertyLayers[i].properties.find(x => x.propertyName.toLocaleLowerCase().indexOf("eu") > -1);
            var existValue = this.garmentConfiguration.garmentLayersPropertyValues[i].propertyValues.find(x => x.values.find(y => y.label == event));
            if(existItem && existValue)
                existItem.propertyValue = event;
        }
    }

    // get disabled(){
    //     if(this.estimationBaseInformation.isIndustrialProduct)
    //         return false;

    //     var result = true;

    //     for(var i = 0; i < this.estimationBaseInformation.garmentPropertyLayers.length; i++){
    //         var el = this.estimationBaseInformation.garmentPropertyLayers[i];
             
    //         if(el.gender){
    //             //Prendo le propertyname con quel gender
    //             var genderPropertyName = this.garmentConfiguration.garmentLayersPropertyValues[i].propertyValues
    //                 .filter( x => x.gender == el.gender)
    //                 .map( x => x.propertyName);
    //             //Distinct
    //             genderPropertyName = [...new Set(genderPropertyName)];
                
    //             var baseInformationPropertySet: OM.GarmentProperty[] = [];
                
    //             this.estimationBaseInformation.garmentPropertyLayers.forEach( x => {
    //                 var result = x.properties.filter( x => {
    //                     return x.propertyValue
    //                 });
    
    //                 baseInformationPropertySet.push(...baseInformationPropertySet)
    //             })
    
    //             //Controllo che abbia messo tutte le property
    //             var propertiesSet = genderPropertyName.length == baseInformationPropertySet.length;

    //             if(!propertiesSet)
    //                 result = propertiesSet;
    //         }
    //     }

    //     return result
    // }
    get disabled() {
        if (this.estimationBaseInformation.isStandaloneIndustrialProduct)
            return !this.estimationBaseInformation.industrialProductSize;

        if (this.estimationBaseInformation.isIndustrialProduct) return false;

        // Per ogni layer...
        for (let i = 0; i < this.estimationBaseInformation.garmentPropertyLayers.length; i++) {
            const layer = this.estimationBaseInformation.garmentPropertyLayers[i];

            if (layer.gender) {
                // Prendo i nomi delle proprietà richieste per quel gender
                const expectedPropertyNames = this.garmentConfiguration.garmentLayersPropertyValues[i].propertyValues
                    .filter(x => x.gender === layer.gender)
                    .map(x => x.propertyName);

                const uniqueExpectedPropertyNames = [...new Set(expectedPropertyNames)];

                // Prendo le property effettivamente valorizzate in quel layer
                const selectedProperties = layer.properties
                    .filter(p => p.propertyValue && p.propertyValue.trim() !== '')
                    .map(p => p.propertyName);

                const uniqueSelectedPropertyNames = [...new Set(selectedProperties)];

                // Se manca almeno una proprietà richiesta, disabilito
                const allRequiredSelected = uniqueExpectedPropertyNames.every(required =>
                    uniqueSelectedPropertyNames.includes(required)
                );

                if (!allRequiredSelected) return true;
            }
        }

        // Tutte le proprietà obbligatorie sono state selezionate correttamente
        return false;
    }

    editBaseInformation(){
        var editBaseInformationVM: OM.EditEstimationBaseInformationVM = {
            identifier: this.estimationBaseInformation.identifier,
            numberOfExtraPockets: this.estimationBaseInformation.extraPocketsNumber,
            garmentPropertyLayers: this.estimationBaseInformation.garmentPropertyLayers,
            industrialProductSelectedSize: this.estimationBaseInformation.industrialProductSize
        };

        if(this.garmentConfiguration.name == "BRA") {
            store.state.estimationClient.editBRABaseInformation(editBaseInformationVM)
            .then( x => {
                if(this.saveToGarmentConfiguration)
                    this.$router.push("/garmentDefaultData/rawmaterials/" + this.estimationIdentifier);
                else
                    this.$router.push("/calculator/rawmaterials/" + this.estimationIdentifier);
            })
        }
        else if(this.garmentConfiguration.name == "BOTTOM UNDERWEAR") {
            store.state.estimationClient.editBOTTOMUNDERWEARBaseInformation(editBaseInformationVM)
            .then( x => {
                if(this.saveToGarmentConfiguration)
                    this.$router.push("/garmentDefaultData/rawmaterials/" + this.estimationIdentifier);
                else
                    this.$router.push("/calculator/rawmaterials/" + this.estimationIdentifier);
            })
        }
        else if(this.garmentConfiguration.name == "LINGERIE") {
            store.state.estimationClient.editLINGERIEBaseInformation(editBaseInformationVM)
            .then( x => {
                if(this.saveToGarmentConfiguration)
                    this.$router.push("/garmentDefaultData/rawmaterials/" + this.estimationIdentifier);
                else
                    this.$router.push("/calculator/rawmaterials/" + this.estimationIdentifier);
            })
        }
        else if(this.garmentConfiguration.name == "PAJAMAS") {
            store.state.estimationClient.editPAJAMASBaseInformation(editBaseInformationVM)
            .then( x => {
                if(this.saveToGarmentConfiguration)
                    this.$router.push("/garmentDefaultData/rawmaterials/" + this.estimationIdentifier);
                else
                    this.$router.push("/calculator/rawmaterials/" + this.estimationIdentifier);
            })
        }
        else {
            store.state.estimationClient.editBaseInformation(editBaseInformationVM)
            .then( x => {
                if(this.saveToGarmentConfiguration)
                    this.$router.push("/garmentDefaultData/rawmaterials/" + this.estimationIdentifier);
                else
                    this.$router.push("/calculator/rawmaterials/" + this.estimationIdentifier);
            })
        }
    }

    // @Watch('bothWastagePercentage')
    // updateWastagePercentage() {
    //     this.estimationBaseInformation.garmentPropertyLayers.forEach(element => {
    //         element.wastagePercentage = this.bothWastagePercentage;
    //     });
    // }
    @Watch('bothWastagePercentage')
    onWastagePercentageChanged = debounce(function () {
        this.estimationBaseInformation.garmentPropertyLayers.forEach(element => {
            element.wastagePercentage = this.bothWastagePercentage;
        });
    }, 100);
}

